// src/app/services/shared.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, shareReplay, tap } from 'rxjs';
import { HttpService } from './http.service';
import { ApiEndpoints } from '../enums/api.enum';
import { Toaster } from '../components/toaster/toaster';
@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private sidebarItemsSubject = new BehaviorSubject<any[]>([]);
    sidebarItems$: Observable<any[]> = this.sidebarItemsSubject.asObservable();

    private toastSubject = new BehaviorSubject<any>({});
    toast$: Observable<any> = this.toastSubject.asObservable();

    constructor(private http: HttpService) { }

    loadSidebarItems(): void {
        this.http.post('sidebar/list', {}).subscribe({
            next: (items: any) => this.sidebarItemsSubject.next(items),
            error: (err) => {
                console.error('Failed to load sidebar items', err);
                this.sidebarItemsSubject.next([]);
            },
        });
    }

    /**
     * Upload a file to the asset storage service.
     * @param folder Destination folder:
     *   - `dm-file` for PDFs / generic files
     *   - `dm-images` for images (attachments, logos, etc.)
     *   - `dm-signature` for user signatures
     */
    uploadFile(
        file: File,
        fileName?: string,
        folder: 'dm-file' | 'dm-images' | 'dm-signature' | 'dm-logo' | 'dm-form-management-pdf' = 'dm-file'
    ): Observable<any> {
        const formData = new FormData();
        formData.append('files', file, fileName || file.name);

        return this.http.postFile(`uploadFile/${folder}`, formData);
    }

}
